import { useAuthStep } from "@/hooks/useAuthStep";
import { trackEvent } from "@/lib/utils";
import { useCommunication } from "@/lib/CommunicationWrapper";

const UnderAge = () => {
    const { closeModal, updateOptions } = useCommunication();
    const { uuid } = useAuthStep();

    const handleExit = () => {
        updateOptions({ auth_state: "underage" });
        closeModal();
        trackEvent("signup_underage", { distinct_id: uuid });
    }

    return (
        <div className="px-[30px] text-gray-500">
            <h1 className="text-2xl font-semibold text-black mb-[5px]">Almost there...</h1>
            <p>You can still use BetterCampus to make your Canvas look awesome - <span className="font-medium text-black">no account needed.</span></p>
            <p className="mt-[20px]">Check back when you turn 13 - we'll be waiting with even more features.</p>
            <p className="mt-[20px]">💙 The BetterCampus Team</p>
            <button className="w-full mt-[20px] text-white px-4 py-2 rounded-full hover:brightness-95 transition-all duration-200" style={{ "background": "linear-gradient(120deg, var(--brand-1), var(--brand-2))" }} onClick={handleExit}>Continue without account</button>
        </div>
    )

}

export default UnderAge;